module.exports = __webpack_public_path__ + "media/benia_budzet.93e43340.mp3";